import {type AvailableCommand, useAvailableCommands} from '@github-ui/copilot-chat/hooks/use-available-commands'
import {ModeSupportName, type StarterEntry} from '@github-ui/copilot-chat/utils/copilot-chat-types'

import {CommandPill} from './CommandPill'
import styles from './CommandStarters.module.css'
import {getStarterGroups} from './starter-groups'
import {StarterGroupWithMenu} from './StarterGroupWithMenu'

type CommandsProps = {
  onSelect: (command: AvailableCommand) => void
  onIceBreakerSelect: (command: StarterEntry) => void
  paidUser?: boolean
  activeModeName?: string
}

export const CommandStarters = ({onSelect, onIceBreakerSelect, paidUser, activeModeName}: CommandsProps) => {
  const {availableCommands} = useAvailableCommands({enabled: true})

  // Legacy starters to show in the icebreakers experiment
  // show only 'git' and 'pull request' for paid users, and also 'write code' for non-paid users
  const legacyStarters = getStarterGroups(true, activeModeName === ModeSupportName.Agent).filter(group => {
    if (group.id === 'git-group' || group.id === 'pull-requests-group') return true
    if (!paidUser && group.id === 'write-code-group') return true
    if (activeModeName === ModeSupportName.Agent) return true
    return false
  })

  // Filter commands based on feature flags and user plan
  const filteredCommands = availableCommands.filter(command => {
    if (activeModeName === ModeSupportName.Agent) return false
    if (command.key === 'ask') return false
    if (!paidUser && command.key === 'spark') return false
    return true
  })

  if (filteredCommands.length === 0 && legacyStarters.length === 0) {
    return null
  }

  return (
    <div className={styles.container}>
      <ul className={styles.list}>
        {filteredCommands.map(command => (
          <li key={command.key}>
            <CommandPill icon={command.icon} onClick={() => onSelect(command)} isNew={command.isNew}>
              {command.name}
            </CommandPill>
          </li>
        ))}
        {legacyStarters.map(group => (
          <StarterGroupWithMenu key={group.id} group={group} onEntrySelect={onIceBreakerSelect} />
        ))}
      </ul>
    </div>
  )
}
